import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject, Component, OnInit } from '@angular/core';

@Component({
  selector: 'xsr-ro-history-dialog',
  templateUrl: './ro-history-dialog.component.html',
  styleUrls: ['./ro-history-dialog.component.css'],
})
export class RoHistoryDialogComponent implements OnInit {
  selectedServiceGroup: any;

  constructor(public dialogRef: MatDialogRef<RoHistoryDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {}

  onCancel(): void {
    this.dialogRef.close({ cancelled: true });
  }
}
